import { render } from "./AppMenu.vue?vue&type=template&id=8fbdfa5c&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8fbdfa5c"

export default script